<!-- eslint-disable vue/no-v-html -->
<template>
  <NoticeBox
    v-if="errors && Object.keys(errors).length"
    class="-error _mb-sm-20 _mb-md-60"
    role="alert"
  >
    <template v-if="columnOnly">
      <NoticeHeader>
        <h3 class="heading">以下の項目をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody v-if="items">
        <ul v-for="key in items" :key="key">
          <li v-if="errors.hasOwnProperty(key)">{{ $t("label." + key) }}</li>
        </ul>
      </NoticeBody>
      <NoticeBody v-else>
        <ul v-for="key in Object.keys(errors)" :key="key">
          <li>{{ $t("label." + key) }}</li>
        </ul>
      </NoticeBody>
    </template>
    <template v-else-if="title">
      <NoticeHeader>
        <h3 class="heading">{{ title }}</h3>
      </NoticeHeader>
    </template>
    <template v-else-if="errorOnly">
      <NoticeHeader v-for="key in Object.keys(errors)" :key="key">
        <h3 v-for="(val, index) in errors[key]" :key="index" class="heading">
          {{ $t("errors.input.message." + val.replace(/\s+/g, "")) }}
        </h3>
      </NoticeHeader>
    </template>
    <template v-else>
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody v-if="items">
        <ul v-for="key in items" :key="key">
          <template v-if="errors.hasOwnProperty(key)">
            <li
              v-for="(val, index) in errors[key]"
              :key="index"
              v-html="
                $t('errors.message.' + val.replace(/\s+/g, ''), {
                  key: $t('label.' + key),
                })
              "
            ></li>
          </template>
        </ul>
      </NoticeBody>
      <NoticeBody v-else>
        <ul v-for="key in Object.keys(errors)" :key="key">
          <li
            v-for="(val, index) in errors[key]"
            :key="index"
            v-html="
              $t('errors.message.' + val.replace(/\s+/g, ''), {
                key: $t('label.' + key),
              })
            "
          ></li>
        </ul>
      </NoticeBody>
    </template>
  </NoticeBox>
</template>

<script>
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "ErrorsAlert",
  components: {
    NoticeBox,
    NoticeHeader,
    NoticeBody,
  },
  props: {
    errors: { type: Object, default: () => {} },
    columnOnly: { type: Boolean },
    errorOnly: { type: Boolean },
    title: { type: String, default: "" },
    items: { type: Object, default: () => {} },
  },
};
</script>

<style lang="scss" scoped></style>
